var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-progress-wrapper"},[_c('div',{staticClass:"line-progress-bar",style:({ background: _vm.color })},[_c('span',{style:({ width: `${_vm.width}%`, background: _vm.color })})]),_vm._v(" "),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }